import React from 'react';
import { ContextWidget } from '../../types/api/Widget';
import { WidgetType } from '../../types/api/ElementType';
import { Icons } from '../../components/atoms/SVG';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { UpcomingEventsBlock } from '../../_blocks/UpcomingEvents/UpcomingEventsBlock';
import { DefaultContextWidget } from '../_utils/asDefaultWidget';

export type UpcomingEventsWidget = ContextWidget<UpcomingEventsBlock, WidgetType.upcomingevents>;

export function UpcomingEventsWidget(props: UpcomingEventsWidget) {
  const { t } = useSonTranslation('UpcomingEvents');
  return <DefaultContextWidget icon={Icons.UPCOMING_EVENTS} title={t('widgetTitle')} {...props} />;
}
